import React from 'react';
import { Helmet } from 'react-helmet';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';

const LoginPage = () => {
  return (
    <>
      <Helmet>
        <title>Iniciar Sesión - MercadoLibre Bulk Publisher</title>
        <meta name="description" content="Inicia sesión en MercadoLibre Bulk Publisher para gestionar y publicar productos de forma masiva en MercadoLibre" />
        <meta name="keywords" content="MercadoLibre, login, bulk publisher, productos, e-commerce" />
      </Helmet>
      <div
        className="relative min-h-screen flex items-center justify-center overflow-hidden px-4 sm:px-6 lg:px-8"
        style={{
          backgroundImage: "url('/assets/images/login-background.avif')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-transparent dark:from-black/70 dark:via-black/60 dark:to-black/70 mix-blend-normal pointer-events-none" aria-hidden="true" />
        <div className="relative w-full max-w-md">
          <div className="rounded-3xl border border-white/40 dark:border-white/10 bg-white dark:bg-[#0f172ae6] shadow-elevated shadow-2xl p-8 space-y-8 transition-smooth">
            <LoginHeader />
            <LoginForm />
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;